module.exports = __webpack_public_path__ + "img/oms-logo.5b382c6a.png";